import { Search as SearchIcon, Assessment as StatsIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { AdminStats } from '../types';

interface AdminStatsSectionProps {
  stats: AdminStats | null;
  loading: boolean;
  onRefresh: () => void;
  resolveResponsive: (values: { xs: number; sm: number; md?: number }) => number;
}

export function AdminStatsSection({ stats, loading, onRefresh, resolveResponsive }: AdminStatsSectionProps) {
  return (
    <Grid size={12}>
      <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <StatsIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>System Logistics</Typography>
            <Box sx={{ ml: 'auto' }}>
              <Tooltip title="Refresh Stats">
                <IconButton onClick={onRefresh} disabled={loading}>
                  {loading ? <CircularProgress size={20} /> : <SearchIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {stats && (
            <Grid container spacing={3}>
              <Grid size={resolveResponsive({ xs: 6, sm: 3 })}>
                <Typography variant="caption" color="text.secondary">Total Citizens</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>{stats.totalUsers}</Typography>
              </Grid>
              <Grid size={resolveResponsive({ xs: 6, sm: 3 })}>
                <Typography variant="caption" color="text.secondary">Free Tier</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>{stats.freeUsers}</Typography>
              </Grid>
              <Grid size={resolveResponsive({ xs: 6, sm: 3 })}>
                <Typography variant="caption" color="text.secondary">Active Subscriptions</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: 'success.main' }}>
                  {stats.activeSubscriptions}
                </Typography>
              </Grid>
              <Grid size={resolveResponsive({ xs: 6, sm: 3 })}>
                <Typography variant="caption" color="text.secondary">Premium Tiers</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
                  {Object.entries(stats.byPlan)
                    .filter(([planId]) => planId !== 'free')
                    .reduce((acc, [, count]) => acc + count, 0)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}
